"use client"
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  styled,
} from "@mui/material"
import React, { useState } from "react"
import { colors, sizes } from "ui"

const StyledAccordion = styled(Accordion)<AccordionProps>`
  &.MuiPaper-root {
    width: 100%;
    padding: ${sizes.baseTriple} 20px;
    color: ${colors.black};
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-bottom-right-radius: unset; // Removes the default
    border-bottom-left-radius: unset; // Removes the default
    border-radius: 20px;
    &:before {
      display: none; // Removes the default
    }
    &.Mui-expanded {
      border: solid 1px ${colors.red};
      margin: 0;
    }
  }
`

const StyledAccordionSummary = styled(AccordionSummary)<AccordionSummaryProps>`
  padding: 0;
  min-height: unset;
  &.MuiAccordionSummary-root {
    padding: 0;
    min-height: unset;
    & .MuiAccordionSummary-content {
      flex-direction: column;
      margin: 0;
    }
  }
`

const StyledAccordionDetails = styled(AccordionDetails)`
  font-size: 16px;
  color: ${colors.black};
  margin-top: 15px;
  padding: 0px;
`

interface AccordionItemProps {
  openIcon: React.ReactNode
  closeIcon: React.ReactNode
  className?: string
  summaryContent: React.ReactNode
  detailsContent: React.ReactNode
  onClick?: () => void
}

const ExtendedPlusMinusCollapse: React.FC<AccordionItemProps> = ({
  openIcon,
  closeIcon,
  className,
  summaryContent,
  detailsContent,
  onClick,
}) => {
  const [expanded, setExpanded] = useState(false)

  const handleChange = () => {
    setExpanded((prev) => !prev)
    onClick && onClick()
  }

  return (
    <StyledAccordion
      expanded={expanded}
      onChange={handleChange}
      className={className}
    >
      <StyledAccordionSummary
        expandIcon={expanded ? closeIcon : openIcon}
        aria-controls="panel-content"
        id="panel-header"
      >
        {summaryContent}
      </StyledAccordionSummary>
      <StyledAccordionDetails>{detailsContent}</StyledAccordionDetails>
    </StyledAccordion>
  )
}

export default ExtendedPlusMinusCollapse
